<template lang="pug">
  .hook-social
    .section
      .container
        .columns
          .column
            .block-center(v-if="success")
              h2 {{ gettext('Supplement information') }}
              .field(v-if="false")
                | {{ gettext('Please select profile type') }}
              .field(v-if="false")
                .field-body
                  button.main-btn.bg-grey(
                  @click="selectType(CONSTANTS.EMPLOYER_PROFILE_TYPE)"
                  :class="{'active': parseInt(type) === parseInt(CONSTANTS.EMPLOYER_PROFILE_TYPE)}")
                    span {{ gettext('Employer') }}
                    span.icon
                      .mdi.mdi-check-circle
                  button.main-btn.bg-grey(
                  @click="selectType(CONSTANTS.JOBSEEKER_PROFILE_TYPE)"
                  :class="{'active': parseInt(type) === parseInt(CONSTANTS.JOBSEEKER_PROFILE_TYPE)}")
                    span {{ gettext('Job seeker') }}
                    span.icon
                      .mdi.mdi-check-circle
              .field
                | {{ gettext('Please select country') }}
              .field
                .field-body
                  ajax-multiselect.wide(
                    v-model="country"
                    :labelText="gettext('Choose the country')"
                    :itemName ="'name'"
                    :action="{method: 'receiveCountries', params:{lang: getLanguage}}",
                    :multiple="false"
                    :searchable="true"
                    :hideSelected="true"
                    :closeOnSelect="true"
                  )
              .field
                .field-body
                  input#agree-checkbox.is-checkradio.is-danger.custom-checkbox(type="checkbox" v-model="agree")
                  label.checkbox(for="agree-checkbox")
                    | {{ gettext('I agree to the') }} &nbsp;
                    router-link(:to="`/${getLanguage}/terms-and-conditions`") {{ gettext('terms and conditions') }}
              .field
                .field-body
                  button.button.main-btn.col-white.bg-red(
                    :disabled="!valid || loading"
                    :class="{'is-loading': loading}"
                    @click="next") {{ gettext('Next') }}
</template>
<script>
import { gettext } from '@/services/TranslateHandler'
import AjaxMultiselect from '@/components/ajax-multiselect'
import { mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import { SocialMixin } from '@/mixins/SocialMixin'

export default {
  name: 'SocialNewUser',
  components: {
    AjaxMultiselect
  },
  mixins: [
    SocialMixin
  ],
  data () {
    return {
      CONSTANTS: CONSTANTS,
      country: parseInt(this.$route.query.user_profile_country) || '',
      type: parseInt(this.$route.query.user_profile_type) || CONSTANTS.JOBSEEKER_PROFILE_TYPE,
      success: true,
      loading: false,
      agree: Boolean(parseInt(this.$route.query.agree))
    }
  },
  methods: {
    gettext: gettext,
    selectType (type) {
      this.type = type
      this.$router.replace({ query: {...this.$route.query, ...{user_profile_type: type}} })
    },
    async next () {
      this.loading = true
      await this.socialNewUser({
        profileType: this.type,
        profileCountry: this.country.id,
        ptoken: this.$route.query.ptoken,
        u: this.$route.query.u,
        agree: this.agree
      })
      this.loading = false
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    valid () {
      return this.type && this.country && this.agree
    }
  },
  watch: {
    country (val) {
      if (val) this.$router.replace({ query: {...this.$route.query, ...{user_profile_country: val.id}} })
    }
  }
}
</script>
<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/hooks/social-new-user/index.vue